import { Card, Heading, Stack, Text } from '@etg/wings';
import ContactMethods from '../../../../../common/components/ContactMethods';
import { bulletStyles } from '../../../../../utils/styleUtils';

interface CancellationProductDrawerProps {
  title: string;
  description: string;
}

const CancellationProductDrawer = ({ title, description }: CancellationProductDrawerProps) => {
  return (
    <Card>
      <Stack>
        <Heading level={2}>{title}</Heading>
        <Text asHtml className={bulletStyles()}>
          {description}
        </Text>
        <ContactMethods chatType="genesys" isCallExpanded />
      </Stack>
    </Card>
  );
};

export default CancellationProductDrawer;
